module.exports = __webpack_public_path__ + "img/card_strair_up.8558cf23.gif";